import { Container } from "../../components/layout/Container.jsx";
import { PageHero } from "../../components/shared/PageHero.jsx";
import { InquiryForm } from "../../components/forms/InquiryForm.jsx";
import { SEO } from "../../lib/seo.jsx";

export default function PreConstructionPage() {
  return (
    <>
      <SEO
        title="Pre-Construction"
        description="Already signed? Reach the pre-construction team for permits, selections, and timeline questions."
      />

      <PageHero
        eyebrow="Pre-construction"
        title="Pre-construction support"
        description="Permits, engineering, soil tests, colour selections — anything between contract signing and site start."
      />

      <Container className="py-16 lg:py-20">
        <div className="mx-auto max-w-2xl rounded-2xl border border-border-subtle bg-bg-elevated p-8">
          <p className="text-sm text-text-secondary">
            Please include your contract reference or job number in the message so we can pull up
            the file before calling back.
          </p>
          <div className="mt-6">
            <InquiryForm
              formType="preconstruction"
              successMessage="Thanks — your pre-construction coordinator will follow up shortly."
            />
          </div>
        </div>
      </Container>
    </>
  );
}
